<template>
  <div class="card p-3">
    <CustomNav
      :items="rightTabs"
      @item-click="(tab) => (activeTabRight = tab)"
      class="mb-3"
    ></CustomNav>
    <template v-if="activeTabRight == 1">
      <PmsFleetDetailHeader :selectedData="selectedData" />
      <table class="table table-striped mb-0">
        <tbody>
          <tr>
            <td class="text-muted">Last Maintenance Date</td>
            <td class="font-semibold text-black">
              {{ formatDate(selectedData?.last_maintenance_date) }}
            </td>
          </tr>
          <tr>
            <td class="text-muted">Due</td>
            <td class="font-semibold text-black">
              <template v-if="selectedData.triggers == 'CALENDAR'">
                {{ formatDate(selectedData.possible_maintenance_date) }}
              </template>
              <template v-else>
                {{
                  formatNumber(selectedData.possible_maintenance_hours) || '0'
                }}
                Hours
              </template>
            </td>
          </tr>
          <tr>
            <td class="text-muted" style="width: 30%">Maintenance Date</td>
            <td class="font-semibold text-black">
              {{ formatDate(selectedData?.last_maintenance_date) }}
            </td>
          </tr>
          <tr v-if="selectedData?.triggers == 'COUNTER'">
            <td class="text-muted">Maintenance Hours</td>
            <td class="font-semibold text-black">
              {{ formatNumber(selectedData?.last_maintenance_hours) }} Hours
            </td>
          </tr>
          <tr>
            <td class="text-muted">Cost</td>
            <td class="font-semibold text-black">
              {{ formatCurrency(selectedData?.last_maintenance_cost) }}
            </td>
          </tr>
          <tr>
            <td class="text-muted">Attachment</td>
            <td>
              <template v-if="selectedData?.attachments?.length">
                <b-badge
                  v-for="(file, idx) in selectedData?.attachments"
                  :key="`att-${idx}`"
                  variant="warning"
                  pill
                  class="mr-2 cursor-pointer"
                  @click="onPreview(file?.fileurl)"
                >
                  {{ file.filename }}
                  <i class="fa fa-download ml-2" style="font-size: 12px"></i>
                </b-badge>
              </template>
              <template v-else>-</template>
            </td>
          </tr>
          <tr>
            <td class="text-muted">Notes</td>
            <td
              class="font-semibold text-black"
              v-html="selectedData?.last_maintenance_notes || '-'"
            ></td>
          </tr>
          <tr>
            <td class="text-muted">Status</td>
            <td>
              <span
                class="badge"
                :class="getStatusBadgeClass(selectedData?.status)"
              >
                {{ selectedData?.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <h4 class="text-primary my-3"><strong>Job Library Info</strong></h4>
      <table class="table table-striped mb-0">
        <tbody>
          <tr>
            <td class="text-muted" style="width: 30%">Job Code</td>
            <td class="font-semibold text-black">
              {{ selectedData?.job_library?.code || selectedData?.job_code || '-' }}
            </td>
          </tr>
          <tr>
            <td class="text-muted">Job Name</td>
            <td class="font-semibold text-black">
              {{ selectedData?.job_library?.name || selectedData?.job_name || '-'}}
            </td>
          </tr>
          <tr>
            <td class="text-muted">Equipment Category</td>
            <td class="font-semibold text-black text-uppercase">
              {{
                selectedData?.job_library?.maintenance_component?.component_name || selectedData?.pms_vehicle?.maintenance_component?.component_name || '-'
              }}
            </td>
          </tr>
          <tr>
            <td class="text-muted">Equipment</td>
            <td class="font-semibold text-black">
              {{
                selectedData?.job_library?.maintenance_master?.equipment_name || selectedData?.pms_vehicle?.maintenance_master?.equipment_name || '-'
              }}
            </td>
          </tr>
          <tr>
            <td class="text-muted">Job Type</td>
            <td class="font-semibold text-black">
              {{
                selectedData?.job_library?.maintenance_job_type?.job_type_index || selectedData?.pms_vehicle?.maintenance_job_type?.job_type_index || '-'
              }}
            </td>
          </tr>
          <tr>
            <td class="text-muted">Method</td>
            <td class="font-semibold text-black">
              {{ selectedData?.job_library?.method || selectedData?.pms_vehicle?.method || '-' }}
            </td>
          </tr>
          <tr>
            <td class="text-muted">Interval</td>
            <td class="font-semibold text-black">
              <template v-if="selectedData?.triggers == 'CALENDAR'">
                {{ selectedData?.job_library?.calendar_interval }}
                {{ selectedData?.job_library?.calendar_type }}
              </template>
              <template v-else>
                {{ formatNumber(selectedData?.trigger_interval) }} Hours
              </template>
            </td>
          </tr>
          <tr v-if="selectedData?.triggers == 'COUNTER'">
            <td class="text-muted">Engine Position</td>
            <td class="font-semibold text-black">
              <template>
                {{ selectedData?.power_type_name || selectedData?.maintenance_power_type?.name || '-' }}
              </template>
            </td>
          </tr>
          <tr v-if="selectedData?.triggers == 'COUNTER'">
            <td class="text-muted">Engine Brand</td>
            <td class="font-semibold text-black">
              {{ selectedData?.power_series_name || selectedData?.maintenance_power_series?.name || '-' }} -
              {{ selectedData?.power_series_model || selectedData?.maintenance_power_series?.model || '-' }}
            </td>
          </tr>
          <tr>
            <td class="text-muted align-top">Job Description</td>
            <td
              class="font-semibold text-black job-description"
              v-html="selectedData?.job_library?.job_description || selectedData?.pms_vehicle?.job_description || '-'"
            ></td>
          </tr>
        </tbody>
      </table>

      <TablePostponed :selectedData="selectedData" />
    </template>
    <template v-else-if="activeTabRight == 2">
      <MaintenanceCommentFormNew isPreview :selectedData="selectedData" />
    </template>
    <template v-else>
      <template v-if="selectedData?.logs?.length">
        <MaintenanceLogs
          :logs="
            selectedData?.logs?.map((log) => ({
              name: log?.user?.detail?.name || log.created_by,
              date: log.created_date,
              description: `Changed Status to ${log.status}`,
            }))
          "
        />
      </template>
    </template>
  </div>
</template>

<script>
import moment from '@/node_modules/moment/moment'
import CustomNav from '@/src/components/global/CustomNav.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import MaintenanceCommentFormNew from './Tabs/MaintenanceCommentFormNew.vue'
import MaintenanceLogs from './Tabs/MaintenanceLogs.vue'
import PmsFleetDetailHeader from './PmsFleetDetailHeader.vue'
import TablePostponed from './TablePostponed.vue'
import { getMiStatusBadgeClass, previewFile } from '@/src/plugins/helpers'

export default {
  name: 'MaintenanceDetail',
  props: {
    selectedData: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    CustomNav,
    MaintenanceCommentFormNew,
    MaintenanceLogs,
    PmsFleetDetailHeader,
    TablePostponed,
  },
  data() {
    return {
      limitOptions,
      activeTabRight: 1,
      rightTabs: [
        { label: 'Maintenance', value: 1 },
        { label: 'Comment', value: 2 },
        { label: 'Logs', value: 3 },
      ],
    }
  },
  computed: {
    filteredRows() {
      let rows = [...this.tableRows]
      if (this.filters.search && this.filters.search.trim() !== '') {
        const s = this.filters.search.toLowerCase().trim()
        rows = rows.filter(
          (r) =>
            r.equipmentName.toLowerCase().includes(s) ||
            r.category.toLowerCase().includes(s) ||
            r.jobType.toLowerCase().includes(s) ||
            r.jobClass.toLowerCase().includes(s)
        )
      }
      return rows
    },
    totalRows() {
      return this.filteredRows.length
    },
    paginatedRows() {
      const start = (this.pagination.page - 1) * this.pagination.limit
      return this.filteredRows.slice(start, start + this.pagination.limit)
    },
  },
  methods: {
    onPreview(fileUrl) {
      previewFile(fileUrl)
    },
    getStatusBadgeClass(status) {
      return getMiStatusBadgeClass(status)
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      return moment(dateStr).format('DD MMMM YYYY')
    },
    formatCurrency(val) {
      if (val === null || val === undefined) return '-'
      const formatted = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(val)
      // Gaya seperti "Rp. 15.500.350,-"
      return formatted.replace('Rp', 'Rp.') + ',-'
    },

    formatNumber(number) {
      if (!number && number !== 0) return '-'

      return Number(number).toLocaleString('id-ID')
    },
  },
}
</script>

<style scoped>
.fleet-image {
  width: 100%;
  height: 240px;
  background: #e9edf4 center/cover no-repeat;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.icon-badge {
  width: 60px;
  height: 60px;
  background: #f4efe6;
  border-radius: 6px;
  display: inline-block;
}
thead.thead-light th {
  background: #f8f9fa;
}
.font-semibold {
  font-weight: 500;
}

:deep(.job-description ul) {
  list-style-type: disc !important;
  padding-left: 20px !important;
  margin-bottom: 10px !important;
}

:deep(.job-description li) {
  list-style-type: disc !important;
  margin-bottom: 5px !important;
  display: list-item !important;
}

:deep(.job-description ol) {
  list-style-type: decimal !important;
  padding-left: 20px !important;
  margin-bottom: 10px !important;
}

:deep(.job-description ol li) {
  list-style-type: decimal !important;
}
</style>
